import { css } from "@emotion/react";

const Story: React.FC = () => {
  return (
    <div css={mainStyle} id="story">
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>ストーリー</div>
          <div css={borderStyle}></div>
        </div>
        <div css={subTitleStyle}>
          速川 唯は、遅刻・忘れ物・居眠りの常習犯で、
          <br />
          恋愛にもオシャレにも関心がないぐうたら女子高生。
          <br />
          なんの目標もなくなんとなく過ごしていたある日、
          <br />
          弟の尊がつくったタイムマシンをうっかり起動させてしまい、
          <br />
          戦国の世へ…!?
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  background-color: rgba(255, 255, 255);
  display: flex;
  justify-content: center;
  background-color: ${primaryColor};
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 30px 20px 40px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: #fff;
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
  color: #fff;
`;

const subTitleStyle = css`
  padding-top: 14px;
  line-height: 18px;
  font-size: 8pt;
  color: white;
  font-weight: bold;
`;

export default Story;
